// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2fbf9dd2" + "." + "3dbefe5fc9c92e6a" + ".js";
};